import { TFunction } from 'i18next'

export const getPairingButtonLabel = (t: TFunction, deviceId?: string, pairingId?: string): string => {
  if (!deviceId) {
    return t('common.edit')
  }
  return pairingId ? t('common.replace') : t('common.pair')
}
